/* eslint-disable no-unused-vars */
import {
  CircularProgress,
  Grid,
  Icon,
  IconButton,
  Typography,
} from "@mui/material";
import PCheck from "../../../components/pos/PCheck";
import PConfirm from "../../../components/pos/PConfirm";
import PDialog from "../../../components/pos/PDialog";
import PRSelect from "../../../components/pos/PRSelect";
import PText from "../../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { SyncUtils } from "../../../utils/SyncUtils";
import SyncIcon from "@mui/icons-material/Sync";
import { PrintUtils } from "../../../utils/PrintUtils";
import axios from "axios";
import { red } from "@mui/material/colors";

export default function TerminalCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState(translate("New Terminal"));
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const [terminalKey, setTerminalkey] = useState("");
  const [terminalKeyError, setTerminalkeyError] = useState("");

  const [deviceId, setDeviceid] = useState("");
  const [deviceIdError, setDeviceidError] = useState("");

  const [invoicePrefix, setInvoicePrefix] = useState("");
  const [invoicePrefixError, setInvoicePrefixError] = useState("");

  const [saleFeature, setSalefeature] = useState(false);
  const [saleReturnFeature, setSaleReturnFeature] = useState(false);
  const [pdtFeature, setPdtfeature] = useState(false);
  const [priceCheckFeature, setPricecheckfeature] = useState(false);
  const [serviceReceiptFeature, setServiceReceiptFeature] = useState(false);
  const [saleOrderFeature, setSaleOrderFeature] = useState(false);
  const [customerPaymentFeature, setCustomerPaymentFeature] = useState(false);

  const [loadFlag, setLoadFlag] = useState("N");

  const [receiptPrinterOptions, setReceiptPrinterOptions] = useState([]);
  const [printerOptions, setPrinterOptions] = useState([]);
  const [comPortOptions, setComPortOptions] = useState([]);

  const [receiptPrinter, setReceiptPrinter] = useState(null);
  const [imagePrinter, setImagePrinter] = useState(null);
  const [poleDisplayPort, setPoleDisplayPort] = useState(null);
  const [androidApp, setAndroidApp] = useState(false);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");

  const [printingModeOptions, setPrintingModeOptions] = useState([
    { value: "CLOUD_PRINT", label: "Cloud print Service" },
    { value: "LOCAL_AGENT", label: "Local agent" },
    { value: "BLUETOOTH", label: "Bluetooth" },
  ]);

  const [printingMode, setPrintingMode] = useState(false);

  const [saleModeOptions, setSaleModeOptions] = useState([
    { value: "TOUCH_POS", label: "Point of sale (Touch ccreens)" },
    {
      value: "TOUCH_POS_TILE",
      label: "Point of Sale (Touch screens with tile view)",
    },
    { value: "KEYBOARD_TRADING", label: "Trading (Keyboard based)" },
  ]);

  const [saleMode, setSaleMode] = useState({
    value: "TOUCH_POS",
    label: "Touch POS",
  });

  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.child = {
    showTerminalCrudWindow: showTerminalCrudWindow,
  };

  useEffect(() => { }, []);

  useEffect(() => {
    if (liveValidation && name === "")
      setNameError(translate("Name is Required"));
    else setNameError("");
  }, [name]);
  /*useEffect(() => {
    if (liveValidation && receiptPrinte === "")
      setReceiptprinteError("Receiptprinte is Required");
    else setReceiptprinteError("");
  }, [receiptPrinte]);
  useEffect(() => {
    if (liveValidation && barcodePrinter === "")
      setBarcodeprinterError("Barcodeprinter is Required");
    else setBarcodeprinterError("");
  }, [barcodePrinter]);
  useEffect(() => {
    if (liveValidation && terminalKey === "")
      setTerminalkeyError("Terminalkey is Required");
    else setTerminalkeyError("");
  }, [terminalKey]);
  useEffect(() => {
    if (liveValidation && poleDisplayPort === "")
      setPoledisplayportError("Poledisplayport is Required");
    else setPoledisplayportError("");
  }, [poleDisplayPort]);
  useEffect(() => {
    if (liveValidation && reportPrinter === "")
      setReportprinterError("Reportprinter is Required");
    else setReportprinterError("");
  }, [reportPrinter]);
  useEffect(() => {
    if (liveValidation && receiptConfig === "")
      setReceiptconfigError("Receiptconfig is Required");
    else setReceiptconfigError("");
  }, [receiptConfig]);
  useEffect(() => {
    if (liveValidation && dayOpenConfig === "")
      setDayopenconfigError("Dayopenconfig is Required");
    else setDayopenconfigError("");
  }, [dayOpenConfig]);
  useEffect(() => {
    if (liveValidation && dayCloseConfig === "")
      setDaycloseconfigError("Daycloseconfig is Required");
    else setDaycloseconfigError("");
  }, [dayCloseConfig]);
  useEffect(() => {
    if (liveValidation && payInConfig === "")
      setPayinconfigError("Payinconfig is Required");
    else setPayinconfigError("");
  }, [payInConfig]);
  useEffect(() => {
    if (liveValidation && payOutConfig === "")
      setPayoutconfigError("Payoutconfig is Required");
    else setPayoutconfigError("");
  }, [payOutConfig]);*/
  useEffect(() => {
    if (liveValidation && deviceId === "")
      setDeviceidError(translate("Device id is required"));
    else setDeviceidError("");
  }, [deviceId]);
  useEffect(() => {
    if (liveValidation && invoicePrefix === "")
      setInvoicePrefixError(translate("invoice prefix is required"));
    else setInvoicePrefixError("");
  }, [invoicePrefix]);
  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  function showTerminalCrudWindow(terminalId) {
    if (terminalId == null) {
      resetFields();
      setMode("create");
      setLiveValidation(false);
      setOpenWindow(true);
    } else {
      setMode("edit");
      populateTerminal(terminalId);
    }
  }
  async function populateTerminal(id) {
    {
      try {
        let { data } = await API.get("/api/v1/terminal/" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive terminal data from server")
        );
      }
    }
  }

  async function populateData(bean) {
    setWindowTitile(bean.name);
    setName(bean.name);

    setTerminalkey(bean.terminalKey);

    setDeviceid(bean.deviceId);

    setInvoicePrefix(bean.setInvoicePrefix);
    setSalefeature(bean.saleFeature);
    setSaleReturnFeature(bean.saleReturnFeature);
    setPdtfeature(bean.pdtFeature);
    setPricecheckfeature(bean.priceCheckFeature);
    setServiceReceiptFeature(bean.serviceReceiptFeature);
    setSaleOrderFeature(bean.saleOrderFeature);
    setCustomerPaymentFeature(customerPaymentFeature);
    setAndroidApp(bean.androidApp);
    setLoadFlag("Y");
    for (let mode of printingModeOptions) {
      if (mode.value === bean.printingMode) {
        setPrintingMode(mode);
      }
    }
    for (let mode of saleModeOptions) {
      if (mode.value === bean.saleMode) {
        setSaleMode(mode);
      }
    }
    for (let n of printingModeOptions) {
      if (n.value === bean.printingMode) {
        setPrintingMode(n);
        if (n.value === "CLOUD_PRINT") {
          let [printers, comports] = await refreshCloudPrinters();
          if (printers) {
            for (let p of printers) {
              if (p.value === bean.receiptPrinter) {
                setReceiptPrinter(p);
              }
              if (p.value === bean.imagePrinter) {
                setImagePrinter(p);
              }
            }
          }
          if (comports) {
            for (let p of comports) {
              if (p.value === bean.poleDisplayPort) {
                setPoleDisplayPort(p);
              }
            }
          }
        }
      }
    }

    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setName("");
    setNameError("");

    setTerminalkey("AUTO");
    setTerminalkeyError("");

    setComPortOptions([]);
    setPrinterOptions([]);

    setDeviceid("");
    setDeviceidError("");
    setInvoicePrefix("");
    setInvoicePrefixError("");
    setSalefeature(false);
    setSaleReturnFeature(false);
    setPdtfeature(false);
    setPricecheckfeature(false);
    setServiceReceiptFeature(false);
    setSaleOrderFeature(false);
    setCustomerPaymentFeature(false);
    setLoadFlag("N");
    setPrintingMode("");
    setSaleMode({ value: "TOUCH_POS", label: "Point of Sale (Touch Screens)" });
    setAndroidApp(false);

    setPrintingMode(null);
    setReceiptPrinter(null);
    setImagePrinter(null);
    setPoleDisplayPort(null);

    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: translate("Are You Sure"),
      message:
        translate("Are you sure to delete terminal") +
        " :" +
        origObject.name +
        " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }

  async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete("/api/v1/terminal/" + origObject.id);
        props.showMessage(
          "warning",
          translate("Terminal") + " " + name + " " + translate("got Removed")
        );
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", translate("Not able to Delete Terminal"));
      }
    }
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSave() {
    if (validate()) {
      var payload = createPayload();
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/terminal", payload);
        props.showMessage("success", translate("Saved Successfully"));
        //SyncUtils.requestSync(result.headers);
        props.onRefresh();
        setOpenWindow(false);
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        console.log(err);
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage("error", translate("Not able to Save Terminal"));
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      if (obj.field === "name") {
        setNameError(obj.message);
      }
      /*if (obj.field === "receiptPrinte") {
        setReceiptprinteError(obj.message);
      }
      if (obj.field === "barcodePrinter") {
        setBarcodeprinterError(obj.message);
      }
      if (obj.field === "terminalKey") {
        setTerminalkeyError(obj.message);
      }
      if (obj.field === "poleDisplayPort") {
        setPoledisplayportError(obj.message);
      }
      if (obj.field === "reportPrinter") {
        setReportprinterError(obj.message);
      }
      if (obj.field === "receiptConfig") {
        setReceiptconfigError(obj.message);
      }
      if (obj.field === "dayOpenConfig") {
        setDayopenconfigError(obj.message);
      }
      if (obj.field === "dayCloseConfig") {
        setDaycloseconfigError(obj.message);
      }
      if (obj.field === "payInConfig") {
        setPayinconfigError(obj.message);
      }
      if (obj.field === "payOutConfig") {
        setPayoutconfigError(obj.message);
      }*/
      if (obj.field === "deviceId") {
        setDeviceidError(obj.message);
      }
      if (obj.field === "invoicePrefix") {
        setInvoicePrefixError(obj.message);
      }
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    console.log(mode);
    saveObject["name"] = name;

    saveObject["terminalKey"] = terminalKey;

    saveObject["deviceId"] = deviceId;
    saveObject["invoicePrefix"] = invoicePrefix;
    saveObject["saleFeature"] = saleFeature;
    saveObject["saleReturnFeature"] = saleReturnFeature;
    saveObject["pdtFeature"] = pdtFeature;
    saveObject["priceCheckFeature"] = priceCheckFeature;
    saveObject["serviceReceiptFeature"] = serviceReceiptFeature;
    saveObject["saleOrderFeature"] = saleOrderFeature;
    saveObject["customerPaymentFeature"] = customerPaymentFeature;
    saveObject["androidApp"] = androidApp;

    saveObject["printingMode"] = printingMode ? printingMode.value : null;
    saveObject["saleMode"] = saleMode ? saleMode.value : null;
    saveObject["receiptPrinter"] = receiptPrinter ? receiptPrinter.value : null;
    saveObject["imagePrinter"] = imagePrinter ? imagePrinter.value : null;
    saveObject["poleDisplayPort"] = poleDisplayPort
      ? poleDisplayPort.value
      : null;

    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = origObject.id;
      saveObject["intVersion"] = origObject.intVersion;
    }
    return saveObject;
  }

  function validate() {
    let flag = true;
    if (!name || name === "") {
      setNameError(translate("Name is Required"));
      flag = false;
    }
    /*if (!receiptPrinte || receiptPrinte === "") {
      setReceiptprinteError("Receiptprinte is Required");
      flag = false;
    }
    if (!barcodePrinter || barcodePrinter === "") {
      setBarcodeprinterError("Barcodeprinter is Required");
      flag = false;
    }
    if (!terminalKey || terminalKey === "") {
      setTerminalkeyError("Terminalkey is Required");
      flag = false;
    }
    if (!poleDisplayPort || poleDisplayPort === "") {
      setPoledisplayportError("Poledisplayport is Required");
      flag = false;
    }
    if (!reportPrinter || reportPrinter === "") {
      setReportprinterError("Reportprinter is Required");
      flag = false;
    }
    if (!receiptConfig || receiptConfig === "") {
      setReceiptconfigError("Receiptconfig is Required");
      flag = false;
    }
    if (!dayOpenConfig || dayOpenConfig === "") {
      setDayopenconfigError("Dayopenconfig is Required");
      flag = false;
    }
    if (!dayCloseConfig || dayCloseConfig === "") {
      setDaycloseconfigError("Daycloseconfig is Required");
      flag = false;
    }
    if (!payInConfig || payInConfig === "") {
      setPayinconfigError("Payinconfig is Required");
      flag = false;
    }
    if (!payOutConfig || payOutConfig === "") {
      setPayoutconfigError("Payoutconfig is Required");
      flag = false;
    }*/

    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  async function refreshCloudPrinters() {
    setLoadFlag("L");
    try {
      let receiptPrinters = [];
      let otherPrinters = [];

      let comports = [];
      comports.push({ value: null, label: "NONE" });
      otherPrinters.push({ value: null, label: "NONE" });

      let [url, token] = await PrintUtils.getCloudPrintToken();
      const config = {
        headers: { Authorization: `Bearer ${token}` },
      };
      let devices = await axios.get(
        "/cloudprintbackend/api/v1/core/devices",
        config
      );

      console.log(devices);
      for (let device of devices.data) {
        console.log(device);
        if (device.deviceFamily === "PRINTER") {
          receiptPrinters.push({
            value: device.id,
            label: device.device,
          });
          otherPrinters.push({
            value: device.id,
            label: device.device,
          });
        }
        if (device.deviceFamily === "COM") {
          comports.push({ value: device.id, label: device.device });
        }
      }
      setReceiptPrinterOptions(receiptPrinters);
      setPrinterOptions(otherPrinters);
      setComPortOptions(comports);

      setLoadFlag("Y");

      return [otherPrinters, comports];
    } catch (err) {
      console.error("##", err);
      setLoadFlag("F");
    }
  }

  async function onChangePringintMode(printingMode) {
    setLoadFlag("L");
    setPrintingMode(printingMode);
    if (printingMode.value === "CLOUD_PRINT") await refreshCloudPrinters();
  }

  const content = (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={6.5}>
          <table width="100%">
            <tbody>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Name")} <sup style={{ color: "red" }}>*</sup>
                  </Typography>
                </td>
                <td>
                  <PText
                    value={name}
                    error={nameError}
                    onChange={(e) => setName(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Terminal key")}
                  </Typography>
                </td>
                <td>
                  <PText
                    disabled={true}
                    value={terminalKey}
                    error={terminalKeyError}
                    onChange={(e) => setTerminalkey(e.target.value)}
                  ></PText>
                </td>
              </tr>

              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Device id")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={deviceId}
                    error={deviceIdError}
                    onChange={(e) => setDeviceid(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Invoice prefix")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={invoicePrefix}
                    error={invoicePrefixError}
                    onChange={(e) => setInvoicePrefix(e.target.value)}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>Sale Screen Type</td>
                <td style={{ width: "400px" }}>
                  <PRSelect
                    options={saleModeOptions}
                    onChange={(e) => {
                      setSaleMode(e);
                    }}
                    value={saleMode}
                  ></PRSelect>
                </td>
              </tr>
            </tbody>
          </table>
          <table width="140%">
            <tbody>
              <tr>
                <Typography variant="body1">{translate("Features")}</Typography>
                <td>
                  <PCheck
                    onChange={(value) => setSalefeature(value)}
                    checked={saleFeature}
                    label={translate("Sale")}
                  ></PCheck>
                </td>
                <td>
                  <PCheck
                    onChange={(value) => setSaleReturnFeature(value)}
                    checked={saleReturnFeature}
                    label={translate("Sale return")}
                  ></PCheck>
                </td>
              </tr>

              <tr>
                <td></td>
                {props.context.appType != "R_POS" && (
                  <td>
                    <PCheck
                      onChange={(value) => setPdtfeature(value)}
                      checked={pdtFeature}
                      label={translate("Purchase")}
                    ></PCheck>
                  </td>
                )}
                {props.context.appType != "R_POS" && (
                  <td>
                    <PCheck
                      onChange={(value) => setPricecheckfeature(value)}
                      checked={priceCheckFeature}
                      label={translate("Price check")}
                    ></PCheck>
                  </td>
                )}
              </tr>
              <tr>
                <td></td>
                {props.context.appType != "R_POS" && (
                  <td width="23%">
                    <PCheck
                      onChange={(value) => setServiceReceiptFeature(value)}
                      checked={serviceReceiptFeature}
                      label={translate("Service receipt")}
                    ></PCheck>
                  </td>
                )}

                {props.context.appType != "R_POS" && (
                  <td>
                    <PCheck
                      onChange={(value) => setSaleOrderFeature(value)}
                      checked={saleOrderFeature}
                      label={translate(
                        props.context.storeAdmin.saleOrderName
                          ? props.context.storeAdmin.saleOrderName
                          : "Sale order"
                      )}
                    ></PCheck>
                  </td>
                )}
              </tr>
              <tr>
                <td></td>
                <td>
                  <PCheck
                    onChange={(value) => setCustomerPaymentFeature(value)}
                    checked={customerPaymentFeature}
                    label={translate("Customer payment")}
                  ></PCheck>
                </td>
              </tr>
            </tbody>
          </table>
          {/* </td>
                <td>
                  <PCheck
                    onChange={(value) => setSalefeature(value)}
                    checked={saleFeature}
                    label={translate("Sale")}
                  ></PCheck>
                </td>
              </tr> */}
          {/* {props.context.appType != "R_POS" && (
                <tr>
                  <td></td>
                  <td>
                    <PCheck
                      onChange={(value) => setPdtfeature(value)}
                      checked={pdtFeature}
                      label={translate("Purchase")}
                    ></PCheck>
                  </td>
                </tr>
              )}
              {props.context.appType != "R_POS" && (
                <tr>
                  <td></td>
                  <td>
                    <PCheck
                      onChange={(value) => setPricecheckfeature(value)}
                      checked={priceCheckFeature}
                      label={translate("Price Check")}
                    ></PCheck>
                  </td>
                </tr>
              )}
              {props.context.appType != "R_POS" && (
                <tr>
                  <td></td>
                  <td>
                    <PCheck
                      onChange={(value) => setServiceReceiptFeature(value)}
                      checked={serviceReceiptFeature}
                      label={translate("Service Receipt")}
                    ></PCheck>
                  </td>
                </tr>
              )}
              {props.context.appType != "R_POS" && (
                <tr>
                  <td></td>
                  <td>
                    <PCheck
                      onChange={(value) => setSaleOrderFeature(value)}
                      checked={saleOrderFeature}
                      label={translate(
                        props.context.storeAdmin.saleOrderName
                          ? props.context.storeAdmin.saleOrderName
                          : "Sale Order"
                      )}
                    ></PCheck>
                  </td>
                </tr>
              )} */}
          {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
          {/* </tbody> */}
          {/* </table> */}
        </Grid>
        <Grid item xs={20} sm={5.5}>
          <table width="100%">
            <tbody>
              <tr>
                <td style={{ width: "120px" }}>Device Type</td>
                <td>
                  <PCheck
                    onChange={(value) => setAndroidApp(value)}
                    checked={androidApp}
                    label={translate("Android app")}
                  ></PCheck>
                </td>
              </tr>
              <tr>
                <td>Printing mode</td>
                <td style={{ width: "200px" }}>
                  <PRSelect
                    options={printingModeOptions}
                    onChange={(e) => {
                      onChangePringintMode(e);
                    }}
                    value={printingMode}
                  ></PRSelect>
                </td>
                <td style={{ width: "10px" }}>
                  {printingMode &&
                    printingMode.value === "CLOUD_PRINT" &&
                    loadFlag == "Y" && (
                      <IconButton
                        color="primary"
                        aria-label=""
                        onClick={refreshCloudPrinters}
                      >
                        <SyncIcon />
                      </IconButton>
                    )}
                  {printingMode &&
                    printingMode.value === "CLOUD_PRINT" &&
                    loadFlag == "L" && (
                      <CircularProgress size={20}></CircularProgress>
                    )}
                  {printingMode &&
                    printingMode.value === "CLOUD_PRINT" &&
                    loadFlag == "F" && (
                      <IconButton aria-label="" onClick={refreshCloudPrinters}>
                        <SyncIcon sx={{ color: red[700] }} />
                      </IconButton>
                    )}
                </td>
              </tr>

              {printingMode &&
                printingMode.value === "CLOUD_PRINT" &&
                loadFlag == "Y" && (
                  <tr>
                    <td>Receipt Printer</td>
                    <td style={{ width: "300px" }}>
                      <PRSelect
                        options={printerOptions}
                        onChange={(e) => {
                          setReceiptPrinter(e);
                        }}
                        value={receiptPrinter}
                      ></PRSelect>
                    </td>
                  </tr>
                )}

              {printingMode &&
                printingMode.value === "CLOUD_PRINT" &&
                loadFlag == "Y" && (
                  <tr>
                    <td>Image Printer</td>
                    <td style={{ width: "300px" }}>
                      <PRSelect
                        options={printerOptions}
                        onChange={(e) => {
                          setImagePrinter(e);
                        }}
                        value={imagePrinter}
                      ></PRSelect>
                    </td>
                  </tr>
                )}

              {printingMode &&
                printingMode.value === "CLOUD_PRINT" &&
                loadFlag == "Y" && (
                  <tr>
                    <td>Pole Display</td>
                    <td style={{ width: "300px" }}>
                      <PRSelect
                        options={comPortOptions}
                        onChange={(e) => {
                          setPoleDisplayPort(e);
                        }}
                        value={poleDisplayPort}
                      ></PRSelect>
                    </td>
                  </tr>
                )}
            </tbody>
          </table>
        </Grid>
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (mode === "create") {
      if (name || name != "") return true;
    }
    if (mode === "edit") {
      if (name !== origObject.name) return true;
    }
    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"lg"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          onDelete={onDelete}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}

      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
